import { Course } from '@mc/api'
import { Button, IconPlayDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import CTA from 'components/CTA'
import { CM_TIMELINE_VIEW_I18N_NAMESPACE } from 'experiments/pen-5613_v1_cm_innovative_swing/i18n'
import { ANCHORS } from '../../../constants'
import { useGetCMInnovativeSwingCopy } from '../../../hooks/useCMInnovativeSwingData'
import { useVideoModal } from '../../../providers/VideoModalProvider'
import { ScrollAnimation } from '../ScrollAnimation'
import { Section } from '../Section'
import { SubtitlePricingCopy } from '../SubtitlePricingCopy'

export const Hero = () => {
  const { t } = useTranslation(CM_TIMELINE_VIEW_I18N_NAMESPACE)
  const { course } = useStaticData<{ course: Course }>()
  const { openVideoModal } = useVideoModal()

  const hasTrailerVideo = course.brightcoveVideoId || course.mediaUuid

  return (
    <ScrollAnimation>
      <Section id={ANCHORS.CLASS}>
        <div className='row justify-content-center mc-text--center'>
          <div className='col-12 col-md-8'>
            <Title />
            <SubtitlePricingCopy />

            <div className='mc-my-8'>
              <div className='d-none d-md-flex justify-content-center'>
                {hasTrailerVideo && (
                  <Button
                    kind='tertiary'
                    className='mc-mr-4'
                    onClick={() => openVideoModal('trailer')}
                  >
                    <IconPlayDefault size='sm' className='mc-mr-2' />
                    {t('variant_1.hero.trailer')}
                  </Button>
                )}

                <CTA />
              </div>

              <div className='d-flex d-md-none'>
                {hasTrailerVideo && (
                  <Button
                    kind='tertiary'
                    className='mc-mr-4'
                    fullWidth
                    onClick={() => openVideoModal('trailer')}
                  >
                    <IconPlayDefault size='sm' className='mc-mr-2' />
                    {t('variant_1.hero.trailer')}
                  </Button>
                )}

                <CTA fullWidth />
              </div>
            </div>
          </div>
        </div>
      </Section>
    </ScrollAnimation>
  )
}

const Title = () => {
  const { course } = useStaticData<{ course: Course }>()
  const copy = useGetCMInnovativeSwingCopy(course)

  return (
    <>
      <div className='d-none d-md-block'>
        <h1 className='mc-text-d3 mc-text--brand mc-text--uppercase mc-mb-4 mc-mt-6 mc-text--balance'>
          {copy}
        </h1>
      </div>
      <div className='d-block d-md-none'>
        <h1 className='mc-text-d2 mc-text--brand mc-text--uppercase mc-mb-4 mc-text--balance'>
          {copy}
        </h1>
      </div>
    </>
  )
}
